import {
  CAMPAIGN_IMAGE_PATH,
  USER_ASSETS_PATH,
  USER_IG_STORY_ASSETS_PATH,
  CHAT_ASSETS_PATH,
} from 'src/config-global';

export function campaignImageName(path?: string | null) {
  if (!path) {
    return path;
  }

  return `${path}`.replaceAll(`${CAMPAIGN_IMAGE_PATH}`, '');
}

export function campaignImage(path?: string | null) {
  if (!path) {
    return '';
  }

  if (path.includes('https://')) {
    return path;
  }

  return `${CAMPAIGN_IMAGE_PATH}${campaignImageName(path)}`;
}

export function userImageName(path?: string) {
  if (!path) {
    return path;
  }

  return `${path}`.replaceAll(`${USER_ASSETS_PATH}`, '');
}

export function userImage(path?: string | null) {
  if (!path) {
    return '';
  }

  if (path.includes('https://')) {
    return path;
  }

  return `${USER_ASSETS_PATH}${userImageName(path)}`;
}

type PathTypes = string[] | string | null;

export function userMediaImage(paths?: PathTypes) {
  const path = Array.isArray(paths) ? paths[0] : paths;

  if (!path) {
    return '';
  }

  if (path.includes('https://')) {
    return path;
  }

  return `${USER_ASSETS_PATH}${path}`;
}

export function userStoryImage(paths?: PathTypes) {
  const path = Array.isArray(paths) ? paths[0] : paths;

  if (!path) {
    return '';
  }

  if (path.includes('https://')) {
    return path;
  }

  return `${USER_IG_STORY_ASSETS_PATH}${path}`;
}

export function chatImageName(path?: string) {
  if (!path) {
    return path;
  }

  return `${path}`.replaceAll(`${CHAT_ASSETS_PATH}`, '');
}

export function chatImage(paths?: PathTypes) {
  const path = Array.isArray(paths) ? paths[0] : paths;

  if (!path) {
    return '';
  }

  if (path.includes('https://')) {
    return path;
  }

  return `${CHAT_ASSETS_PATH}${chatImageName(path)}`;
}
